import { HardBreak as e } from "../../node_modules/@tiptap/extension-hard-break/dist/index.mjs";
const s = e.extend({
  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (r) => r.getAttribute("class"),
        renderHTML: (r) => r.class ? { class: r.class } : {}
      }
    };
  }
}), a = e.extend({
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.setHardBreak()
    };
  }
});
export {
  s as HardBreakExtension,
  a as SimpleHardBreakExtension
};
